<template>
    <div>
        <b-form-timepicker 
        v-model="content" 
        :placeholder="field.constraints.placeholder"
        :hour12="!customData.timepicker.is24h"
        :show-seconds="customData.timepicker.showSeconds"
        :minutes-step="customData.timepicker.minuteStep"
        :value="field.constraints.default"
        v-bind="$attrs"
        >
        </b-form-timepicker>
         <b-form-invalid-feedback :id="field.key" style="display:block">
          {{ errors[0] || null }}
        </b-form-invalid-feedback>
    </div>
</template>

<script>

export default {
    name: "IdentityField_Time",
    components: {},
    props: {
        field: {
            type: Object
        },
        value: {
            type: Date | String
        },
        translator: {
            type: Function
        }
    },
    data: function() {
        return {
            errors: []
        }
    },
    watch: {
        content(val) {
            this.check(val)
        }
    },
    computed: {
        content: {
            get() {
                return this.value;
            },

            set(val) {
                this.check(val)
            }
        },

        customData() {
            return this.field.constraints.custom_data || {
                timepicker: {
                    is24h: false,
                    showSeconds: false,
                    minuteStep: 1
                }
            }
        }
    },
    methods: {
        check(val) {
            this.errors = []

            if (!this.field.constraints.required) return this.$emit('input', val);
            
            if (val == "") {
                 this.errors.push(this.translator("identityField.requiredField"))
            }
            
            this.$emit("error", {field: this.field.key, error: this.errors.length > 0})
        },

        context(e) {
            //console.log(e)
        }
    },
    
    mounted() {
        this.check(this.content)
    }
}
</script>